module.exports = new __parcel__URL__("falling_sand_incremental_bg.8a0f899a.wasm").toString();